<template>
    <div>
        <h2 v-if="block.value.title">{{ block.value.title }}</h2>
        <table v-if="block.value.table.data.length">
            <!-- Table head -->
            <thead v-if="block.value.table.first_row_is_table_header">
                <tr>
                    <th v-for="(col, idx) in block.value.table.data[0]" :key="idx" class="table-tile">
                        {{ col }}
                    </th>
                </tr>
            </thead>
            <!-- Table body -->
            <tbody class="border-blue">
                <tr v-if="!block.value.table.first_row_is_table_header">
                    <th v-for="(col, idx) in block.value.table.data[0]" :key="idx">
                        {{ col }}
                    </th>
                </tr>
                <tr v-if="block.value.table.data.length > 1" v-for="(row, rowIdx) in block.value.table.data.slice(1)"
                    :key="rowIdx">
                    <td v-for="(col, colIdx) in row" :key="colIdx"">
                        {{ col }}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import LoadingIndicator from '@/components/LoadingIndicator'

export default {
    name: 'TableBlock',
    components: {
        LoadingIndicator
    },
    props: {
        block: Object
    },
}
</script>


<style lang="scss" scoped>
@import "../../assets/styles/vars";

h2 {
    font-size: 1.17em;
}

.table-title {
    font-weight: 700;
}

table {
    width: 100%;
    table-layout: fixed;
    border-collapse: collapse;

    th,
    td {
        padding: 8px;
        text-align: left;
        word-wrap: break-word;
        border: 1px solid $color-gray;
    }
}
</style>